(function () {
  var bar = document.querySelector('[data-trustpilot-bar]');
  var ticking = false;

  function onScroll() {
    if (!bar) return;
    if (window.scrollY < 10) {
      bar.classList.remove('tp-bar--hidden');
    } else {
      bar.classList.add('tp-bar--hidden');
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(onScroll);
      ticking = true;
    }
  }, { passive: true });

  var bubble = document.querySelector('.cart-count-bubble');
  var lastCount = bubble ? bubble.textContent.trim() : null;
  var observer = new MutationObserver(function () {
    var current = document.querySelector('.cart-count-bubble');
    if (!current) return;
    var text = current.textContent.trim();
    if (text !== lastCount) {
      current.classList.remove('hp-bump');
      void current.offsetWidth;
      current.classList.add('hp-bump');
      lastCount = text;
    }
  });
  var cartIcon = document.getElementById('cart-icon-bubble');
  if (cartIcon) {
    observer.observe(cartIcon, { childList: true, subtree: true, characterData: true });
  }

  var navMenus = document.querySelectorAll('.header__inline-menu header-menu');
  navMenus.forEach(function (menu) {
    var closeTimer;
    var details = menu.querySelector('details');
    if (!details) return;

    function openSub() {
      clearTimeout(closeTimer);
      details.open = true;
    }

    function closeSub() {
      details.open = false;
    }

    menu.addEventListener('mouseenter', openSub);
    menu.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(closeSub, 200);
    });
  });

  var drawerSearchTrigger = document.querySelector('[data-drawer-search-trigger]');
  if (drawerSearchTrigger) {
    drawerSearchTrigger.addEventListener('click', function () {
      var drawerDetails = document.getElementById('Details-menu-drawer-container');
      if (drawerDetails) drawerDetails.removeAttribute('open');
      var searchSummary = document.querySelector('.header__search summary');
      if (searchSummary) {
        setTimeout(function () { searchSummary.click(); }, 150);
      }
    });
  }
})();
